import SwapMyBoxModal from './SwapMyBoxModal';

export default SwapMyBoxModal;
